import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { extractAdReferralData, storeReferralData } from '../utils/adReferralTracking';

/**
 * ReferralTracker Component
 * Handles detection and registration of ad referral parameters with PostHog
 * Should be mounted once at the app level
 */
const ReferralTracker = () => {
  const posthog = usePostHog();
  const location = useLocation();

  useEffect(() => {
    if (!posthog) return;

    const initializeReferralTracking = () => {
      try {
        // Extract referral data from current URL
        const referralData = extractAdReferralData();
        
        if (referralData) {
          console.log('Ad referral data detected:', referralData);
          
          // Store in session storage for persistence
          storeReferralData(referralData);
          
          // Register as session properties in PostHog
          // These will be included in all future events for this session
          posthog.register(referralData);
          
          // Also capture a specific event for referral tracking
          posthog.capture('ad_referral_detected', {
            ...referralData,
            detection_method: 'url_parameters',
            page_path: location.pathname
          });
          
          // Clean the URL to remove referral parameters (optional - improves UX)
          // Uncomment the lines below if you want to clean the URL
          /*
          const cleanUrl = new URL(window.location);
          Object.keys(referralData).forEach(param => {
            if (param.startsWith('original_')) {
              const originalParam = param.replace('original_', '');
              cleanUrl.searchParams.delete(originalParam);
            }
          });
          
          // Update browser history without the referral parameters
          if (cleanUrl.href !== window.location.href) {
            window.history.replaceState({}, document.title, cleanUrl.href);
          }
          */
        }
      } catch (error) {
        console.warn('Referral tracking initialization failed:', error);
      }
    };

    // Initialize on component mount and URL changes
    initializeReferralTracking();

  }, [posthog, location]); // Re-run when location changes

  // This component doesn't render anything
  return null;
};

export default ReferralTracker;
